import Error404 from '../views/404.vue'

export default [{
  path: 'error404',
  name: 'error404',
  component: Error404
}]
